var _ellipse, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpenTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.9693,
    cy: 16,
    rx: 15.9693,
    ry: 16,
    fill: "#2057A6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6656_3033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.718 14.5V22.75C15.972 22.75 12.691 22.75 10.7289 22.75C9.90207 22.75 9.23242 22.0784 9.23242 21.25V10.75C9.23242 9.92157 9.90271 9.25 10.7295 9.25L21.2094 9.25C22.0362 9.25 22.7065 9.92157 22.7065 10.75V14.5H16.718ZM15.2209 14.5H10.7295V17.5H15.2209V14.5ZM15.2209 21.25V19H10.7295V21.25H15.2209ZM16.718 10.75V13H21.2094V10.75H16.718ZM15.2209 10.75H10.7295V13H15.2209V10.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2094 22.75V20.5H18.9637V19H21.2094V16.75H22.7065V19H24.9522V20.5H22.7065V22.75H21.2094Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6656_3033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9655,
    height: 18,
    fill: "white",
    transform: "translate(6.98633 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenTable);
export default __webpack_public_path__ + "static/media/OpenTable.2c76bfd55ab734edde83ef74a3b9d9f2.svg";
export { ForwardRef as ReactComponent };